/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
import React, { createContext, useContext, useState } from "react";

export const OrdersContext: React.Context<any> = createContext(null);
export const OrdersProvider = ({ children }: any) => {
  const [orders, setOrders] = useState({});

  return (
    <OrdersContext.Provider value={{ orders, setOrders }}>
      {children}
    </OrdersContext.Provider>
  );
};

export const useOrdersValue = () => useContext(OrdersContext);
